import React from 'react';
import { MdWarning, MdClose, MdCheckCircle, MdArrowUpward } from 'react-icons/md';

const PromotionConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  selectedStudents,
  currentClass,
  nextClass,
  loading = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-md flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl w-full max-w-md">
        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b border-gray-200">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-orange-100 rounded-full">
              <MdWarning className="text-orange-600 text-xl" />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-gray-900">Confirm Promotion</h2>
              {/*<p className="text-sm text-gray-500">This action cannot be undone</p>*/}
            </div>
          </div>
          <button
            onClick={onClose}
            disabled={loading}
            className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors disabled:opacity-50"
          >
            <MdClose size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Promotion Details */}
          <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <div className="flex items-center space-x-3">
              <MdArrowUpward className="text-blue-600" size={20} />
              <div className="text-sm text-blue-800">
                <p className="font-medium mb-1">Promotion Details</p>
                <div className="space-y-1">
                  <p>• <strong>{selectedStudents.length}</strong> student(s) will be promoted</p>
                  <p>• From: <strong>{currentClass?.class_name}</strong></p>
                  <p>• To: <strong>{nextClass?.class_name}</strong></p>
                </div>
              </div>
            </div>
          </div>

          {/* Student List Preview */}
          <div className="mb-6">
            <h3 className="text-sm font-medium text-gray-900 mb-3">Students to be promoted:</h3>
            <div className="max-h-32 overflow-y-auto space-y-2">
              {selectedStudents.slice(0, 5).map((student) => (
                <div key={student._id} className="flex items-center space-x-3 p-2 bg-gray-50 rounded-lg">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                    <span className="text-blue-600 font-medium text-xs">
                      {student.firstname?.[0]}{student.lastname?.[0]}
                    </span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-900">
                      {student.firstname} {student.lastname}
                    </p>
                    <p className="text-xs text-gray-500">ID: {student.registration_id}</p>
                  </div>
                </div>
              ))}
              {selectedStudents.length > 5 && (
                <div className="text-center py-2">
                  <p className="text-sm text-gray-500">
                    ... and {selectedStudents.length - 5} more student(s)
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* Warning */}
          <div className="mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
            <div className="flex items-start space-x-3">
              <MdWarning className="text-yellow-600 mt-0.5" size={16} />
              <div className="text-sm text-yellow-800">
                <p className="font-medium mb-1">Important:</p>
                <ul className="space-y-1 text-yellow-700">
                  <li>• Student records will be moved to the next class</li>
                  <li>• Academic history will be preserved</li>
                  {/*<li>• This action cannot be undone</li>*/}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end space-x-3 p-6 border-t border-gray-200 bg-gray-50">
          <button
            onClick={onClose}
            disabled={loading}
            className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className="inline-flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                Promoting...
              </>
            ) : (
              <>
                <MdCheckCircle className="mr-2" size={16} />
                Confirm Promotion
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromotionConfirmationModal;
